import { render, staticRenderFns } from "./NetPromoter.vue?vue&type=template&id=2f57f48c"
import script from "./NetPromoter.vue?vue&type=script&lang=js"
export * from "./NetPromoter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports